var quickShopping = require('./quickShopping');

const updateSortOptions = (response) => {
    const $tempDom = $('<div>').append($(response));
    const sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;

    sortOptions.forEach((option) => {
        $(`option.${option.id}`).val(option.url);
    });
};

const concatPageParam = (url, page) => {
    let newUrl = url.replace(/(p=)(.*)/g, `p=${page}`);
    if (newUrl.indexOf('?') !== -1) {
        newUrl = newUrl === url ? `${url}&p=${page}` : newUrl;
    } else {
        newUrl = newUrl === url ? `${url}?p=${page}` : newUrl;
    }

    return newUrl;
};

const getUrlForPage = (url, page, sz) => {
    const startPoint = page === 1 ? 0 : sz * (page - 1);

    return url.replace(/(start=)(.*)(?=&)/g, `start=${startPoint}`);
};

module.exports = {
    paginationFunction: () => {
        $('.container').on('click', '.paginator span', (e) => {
            e.stopPropagation();
            let element = $(e.target);
            const elClass = element.attr('class');
            let page = element.data('page');
            let pageSize = element.data('sz');
            const sort = $('.paginator')
                .parent()
                .data('sort-options');


            if (!page) {
                const islinkPage = element.hasClass('paginator-item');
                if (islinkPage) {
                    element = $(element).parent();
                    page = element.data('page');
                    pageSize = element.data('sz');
                }
            }


            const pageUrl = element.data('url')
                || getUrlForPage(
                    sort.options.find(option => option.id === sort.ruleId).url,
                    page,
                    parseInt(pageSize, 10),
                );
            if (!pageUrl || elClass === 'active') return;

            e.preventDefault();
            $.spinner().start();

            window.history.pushState(null, null, concatPageParam(window.location.href, page));

            $.ajax({
                url: pageUrl,
                data: { selectedUrl: pageUrl },
                method: 'GET',
                success(response) {
                    $('body,html').animate({
                        scrollTop: 0,
                    }, 100);
                    $('.row.product-grid').html(response);
                    updateSortOptions(response);
                    quickShopping.assignQuickShopping();

                    $.spinner().stop();

                    if (window.dataLayer) {
                        $('body').trigger('datalayer:updateGrid');
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
		$('.container').on('keydown', '.paginator [tabindex="0"]', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				$(e.currentTarget).trigger('click');
			}
		});
    },
};
